module.exports = __webpack_public_path__ + "static/media/speech.31b0be1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/AdminMapView/speech.png
// module id = 817
// module chunks = 0